import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  TemplateRef,
  viewChild,
} from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { injectTellentIsOneSettingsEnabled } from '@core/tellent-logic';
import { TellentBrand } from '@core/tellent-types';

@Component({
  selector: 'tlc-app-logo',
  templateUrl: './tellent-app-logo.component.html',
  styleUrl: './tellent-app-logo.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, TranslatePipe],
  host: {
    '[class]': 'logo().className',
  },
})
export class TellentAppLogoComponent {
  public isOneSettingsEnabled = injectTellentIsOneSettingsEnabled();

  public brand = input.required<TellentBrand>();
  public width = input<number | 'auto'>('auto');
  public isTaglineVisible = input<boolean>(true);

  public settingsLogotype = viewChild.required<'settingsLogotype', TemplateRef<void>>(
    'settingsLogotype',
    { read: TemplateRef },
  );

  public tellentLogotype = viewChild.required<'tellentLogotype', TemplateRef<void>>(
    'tellentLogotype',
    { read: TemplateRef },
  );

  public recruiteeSymbol = viewChild.required<'recruiteeSymbol', TemplateRef<void>>(
    'recruiteeSymbol',
    { read: TemplateRef },
  );

  public recruiteeTagline = viewChild.required<'recruiteeTagline', TemplateRef<void>>(
    'recruiteeTagline',
    { read: TemplateRef },
  );

  public hrSymbol = viewChild.required<'hrSymbol', TemplateRef<void>>('hrSymbol', {
    read: TemplateRef,
  });

  public hrTagline = viewChild.required<'hrTagline', TemplateRef<void>>('hrTagline', {
    read: TemplateRef,
  });

  public growSymbol = viewChild.required<'growSymbol', TemplateRef<void>>('growSymbol', {
    read: TemplateRef,
  });

  public growTagline = viewChild.required<'growTagline', TemplateRef<void>>('growTagline', {
    read: TemplateRef,
  });

  public logo = computed(() => {
    const isTaglineVisible = this.isTaglineVisible();
    const brand = this.brand();

    switch (brand) {
      case TellentBrand.Kiwi:
      case TellentBrand.Javelo:
        return {
          className: 'hr',
          symbol: this.hrSymbol(),
          tagline: isTaglineVisible ? this.hrTagline() : null,
        };

      case TellentBrand.Recruitee:
        return {
          className: 'recruitment',
          symbol: this.recruiteeSymbol(),
          tagline: isTaglineVisible ? this.recruiteeTagline() : null,
        };

      default:
        if (this.isOneSettingsEnabled) {
          return {
            className: 'settings',
            symbol: this.settingsLogotype(),
            tagline: null,
          };
        }

        return {
          className: 'tellent',
          symbol: this.tellentLogotype(),
          tagline: null,
        };
    }
  });
}
